export default {"src":"/_next/static/media/interior-logo.81cc36fb.svg","height":48,"width":109,"blurWidth":0,"blurHeight":0};